import { render, staticRenderFns } from "./InfoSection.vue?vue&type=template&id=1b0b90b3&scoped=true"
import script from "./InfoSection.vue?vue&type=script&lang=js"
export * from "./InfoSection.vue?vue&type=script&lang=js"
import style0 from "./InfoSection.vue?vue&type=style&index=0&id=1b0b90b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0b90b3",
  null
  
)

export default component.exports